import { render, staticRenderFns } from "./dataItem.vue?vue&type=template&id=40054906&scoped=true"
import script from "./dataItem.vue?vue&type=script&lang=js"
export * from "./dataItem.vue?vue&type=script&lang=js"
import style0 from "./dataItem.vue?vue&type=style&index=0&id=40054906&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40054906",
  null
  
)

export default component.exports